/* Category accordion */
const accBtns = document.getElementsByClassName("acc-btn");
const accContent = document.getElementsByClassName("acc-content");
const accArrows = document.getElementsByClassName('arrow')

for (let i = 0; i < accContent.length; i++) {
    if (accContent[i].classList.contains('show-content')) {
        accContent[i].style.maxHeight = accContent[i].scrollHeight + "px";
        accContent[i].classList.remove('show-content')
    }
}

for (let i = 0; i < accBtns.length; i++) {
    accBtns[i].addEventListener("click", function(e) {

        for (let k = 0; k < accArrows.length; k++) {
            accArrows[k].classList.remove('rotate-arrow')
        }

        if (e.target.children[1]) {
            e.preventDefault()

            e.target.children[1].classList.add('rotate-arrow')

            const content = this.nextElementSibling;
            for (let j = 0; j < accContent.length; j++) {
                accContent[j].style.maxHeight = null;
            }

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }
    });
}